import _ from 'lodash';
import { paywayLinealChannels } from 'services/api/payway/linealChannels';
import { getContentList } from 'services/api/content/list';
import { GetRegion } from 'constants.js';
import { getBrowser } from 'containers/Player/utils/platforms';
import { GetEpgVersion, tvEverywhereEnable } from '../utils/getEpgParams';
import {setLinealChannelData} from "reducers/linealChannel/actions";

export const SET_ERR_DOWNLOAD = 'set_err_download';
export const setErrorDownload = errorData => ({
  type: SET_ERR_DOWNLOAD,
  errorData,
});

export const GET_INFINITE_LIST = 'get_infinite_list';
export const getInfiniteList = List => ({ type: GET_INFINITE_LIST, List });

export const GET_CHANNELS_LIST = 'get_channels_list';
export const getChannelsList = List => ({ type: GET_CHANNELS_LIST, List });

export const infiniteListData = (params, cb) => dispatch => {
  getContentList(params)
    .then(data => {
      if (cb) cb(data);
      return dispatch(getInfiniteList(data));
    })
    .catch(e => {
      if (cb) cb(e);
      dispatch(setErrorDownload(e));
    });
};

export const fetchPaywayLinealChannels = (config, args, cb) => async (
  dispatch,
  getState,
) => {
  const { metadata } = getState();
  const browser = getBrowser();
  const { timeshift_npvr_configuration } = metadata;
  const npvrConfig =
    (timeshift_npvr_configuration &&
      JSON.parse(timeshift_npvr_configuration)) ||
    {};

  const npvrByRegion = npvrConfig[GetRegion()] || npvrConfig.default || {};
  const npvrEnable = npvrByRegion[browser] || npvrByRegion.default || {};
  const { timeshift, npvr } = npvrEnable;
  const linealParams = {
    ...(timeshift && timeshift.enable && { ts: 1 }),
    ...(npvr && npvr.enable && { npvr: 1 }),
  };
  
  const resul = await paywayLinealChannels(linealParams)

  localStorage.setItem(
    'linealChannelData',
    resul?.response?.paqs?.paq && JSON.stringify(resul.response.paqs.paq),
  );
  const status = _.get(resul, 'status', '1');

  if (status !== '0') {
    const error = _.get(
      resul,
      'errors.code',
      _.get(resul, 'errors.error.0', ''),
    );
    if (cb && typeof cb === 'function') {
      cb(error);
    }
    const data = { error, hasError: true };
    return dispatch(setLinealChannelData(data));
  }
  dispatch(setLinealChannelData(resul));
  if (cb && typeof cb === 'function') cb();
  return //dispatch(getChannelsList(resul));
};
